import createCache from '@emotion/cache'

export default function cacheEmotion() {
  return createCache({ key: 'css' })
}
